import { createReducer } from '@reduxjs/toolkit'
import { SimulationResult } from '../../core/models/SimulationResult'
import { executeSimulation } from '../../core/use-cases/executeSimulation'
import { AppState } from '../store'
import { changeSimulationType } from './simulation.reducer'

export type SimulationResultState = {
  loading: boolean
  value: SimulationResult | null
}

const initialState: SimulationResultState = {
  loading: false,
  value: null,
}

export const simulationResultReducer = createReducer(initialState, builder => {
  builder.addCase(executeSimulation.pending, state => {
    state.loading = true
  })
  builder.addCase(executeSimulation.fulfilled, (state, action) => {
    state.loading = false
    state.value = action.payload
  })
  builder.addCase(changeSimulationType, state => {
    state.value = null
  })
})

export const selectSimulationResult = (state: AppState) =>
  state.simulationResult.value
